import React from 'react';
import { Collapse } from "antd";
import ApplicationFormPanel from "./ApplicationFormPanel";
import SectionProblems from "./SectionProblems";
import RequestUploadsPanel from "./RequestUploadsPanel";
import StageAndRequiredRangeSetter from "./StageAndRequiredRangeSetter";

const { Panel } = Collapse;
function UploadSectionCollapse({section}) {
    const openPanels = ['1']
    if (section?.progress?.alertTitle){
        openPanels.push('2');
    }

    return (
        <Collapse size="small" defaultActiveKey={openPanels} key={section.name + section.index} >
            <Panel header="Section Problems" key="1">
                <SectionProblems section={section}/>
            </Panel>

            <Panel header="User Portal Configuration" key="2">

                <div className="d-col gap-6">

                    <StageAndRequiredRangeSetter section={section}/>
                    <RequestUploadsPanel section={section}/>
                </div>

            </Panel>

            <Panel header="User Provided Values" key="3">
                <ApplicationFormPanel section={section}/>
            </Panel>
        </Collapse>
    );
}

export default UploadSectionCollapse;